export default {
    membership(data) {
        let sportStr = '';
        if(data.sport){
            sportStr = data.sport;
        }

        return axios.get('/api/ecommerce/membership/' + sportStr);
    },
    coupon(data) {
        return axios.post('/api/ecommerce/membership/coupon/validate', data);
    },
    voucher(data) {
        return axios.post('/api/ecommerce/membership/voucher/validate', data);
    },
    payrego(data) {
        let sportStr = '';
        if(data.sport){
            sportStr = data.sport;
        }

        return axios.post('/api/ecommerce/membership/' + sportStr, data);
    }
};
